import React from 'react'

import moment from 'moment'

import { Paper, Typography, makeStyles } from '@material-ui/core'

import { CalendarTodayOutlined } from '@material-ui/icons'

import Changes from './../Changes'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const LogAudited = ({ log, field }) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root}>
      <div className={classes.containerDate}>
        <CalendarTodayOutlined color="disabled" className={classes.icon} />

        <Typography variant="h5">
          {moment(log.createdAt)
            .utc(false)
            .format('DD/MM/YYYY')}{' '}
          às{' '}
          {moment(log.createdAt)
            .utc(false)
            .format('HH:mm:ss.SSS')}
        </Typography>
      </div>

      <Typography variant="body2">
        Ação:{' '}
        <span className={classes.value}>
          {helpers.logs.formatAction(log.action)}
        </span>
      </Typography>

      <Typography variant="body2">
        Tipo: <span className={classes.value}>{log.auditableType}</span>
      </Typography>

      <Typography variant="body2">
        IP: <span className={classes.value}>{log.remoteAddress}</span>
      </Typography>

      <Changes log={log} field={field} />
    </Paper>
  )
}

export default LogAudited
